/* eslint-disable import/prefer-default-export */
import dayjs from 'dayjs';

import { intl } from '~lib/intl';

export const getDayLimit = (futureOrdersEnabled, settings) => {
  const { maxDaysAvailableFutureOrder = 0 } = settings;
  return futureOrdersEnabled
    ? dayjs().tz(intl.timezone).add(maxDaysAvailableFutureOrder, 'd').endOf('day')
    : dayjs().tz(intl.timezone);
};
